import * as Errors from '../../../../Shared/Constants/Errors';
import {TFocusableNodeType as TFocusableNodeTypeValues} from '../../../../Tree/Constants/FocusableNodeType';
import ComponentDisplayName from '../Constants/ComponentDisplayName';
import TContainerPropsMap from '../Types/TContainerPropsMap';

import isGridProps from './isGridProps';
import isVirtualHorizontalListProps from './isVirtualHorizontalListProps';
import isVirtualVerticalListProps from './isVirtualVerticalListProps';

const validateProps = <
    TFocusableNodeType extends TFocusableNodeTypeValues,
    TContainerProps extends TContainerPropsMap[TFocusableNodeTypeValues]
>(
    type: TFocusableNodeType,
    props: TContainerProps,
    warn = console.warn.bind(console)
): void => {
    if (isGridProps(type, props)) {
        if (typeof props.columns !== 'number') {
            warn(Errors.PROP_NOT_PROVIDED(ComponentDisplayName.GRID, 'columns'));
        }
    } else if (isVirtualHorizontalListProps(type, props)) {
        if (typeof props.startIndex !== 'number') {
            warn(Errors.PROP_NOT_PROVIDED(ComponentDisplayName.VIRTUAL_HORIZONTAL_LIST, 'startIndex'));
        }

        if (typeof props.onFocusWillChange !== 'function') {
            warn(Errors.PROP_NOT_PROVIDED(ComponentDisplayName.VIRTUAL_HORIZONTAL_LIST, 'onFocusWillChange'));
        }

        if (typeof props.virtualFocusedIndex !== 'number') {
            warn(Errors.PROP_NOT_PROVIDED(ComponentDisplayName.VIRTUAL_HORIZONTAL_LIST, 'virtualFocusedIndex'));
        }

        if (typeof props.itemsLength !== 'number') {
            warn(Errors.PROP_NOT_PROVIDED(ComponentDisplayName.VIRTUAL_HORIZONTAL_LIST, 'itemsLength'));
        }
    } else if (isVirtualVerticalListProps(type, props)) {
        if (typeof props.startIndex !== 'number') {
            warn(Errors.PROP_NOT_PROVIDED(ComponentDisplayName.VIRTUAL_VERTICAL_LIST, 'startIndex'));
        }

        if (typeof props.onFocusWillChange !== 'function') {
            warn(Errors.PROP_NOT_PROVIDED(ComponentDisplayName.VIRTUAL_VERTICAL_LIST, 'onFocusWillChange'));
        }

        if (typeof props.virtualFocusedIndex !== 'number') {
            warn(Errors.PROP_NOT_PROVIDED(ComponentDisplayName.VIRTUAL_VERTICAL_LIST, 'virtualFocusedIndex'));
        }

        if (typeof props.itemsLength !== 'number') {
            warn(Errors.PROP_NOT_PROVIDED(ComponentDisplayName.VIRTUAL_VERTICAL_LIST, 'itemsLength'));
        }
    }
};

export default validateProps;
